'use strict';

var React = require('react');

var Modal = require('../plugins/modal/');


var isNode = typeof document === 'undefined';
if (!isNode) {
    require('./howto.scss');
}

var Howto = React.createClass({
    getInitialState: function() {
        return {
            render: true,  // #262 How To link breaks in Safari after Modal closed
        };
    },
    close: function() {
        var _this = this;
        this.setState({ render: false }, function() { _this.setState({render: true }); });  // #262
    },
    render: function() {
        if (!this.state.render) { return null; } // # 262
        return (
            <div className='howto' ref='howto-fix-safari'>
                <Modal label='How to purchase products?' width={800} height={600}  onClose={this.close}>
                    <div className='howto-content' dangerouslySetInnerHTML={{__html: this.props.text}} />
                </Modal>
            </div>
        );
    },
});

module.exports = Howto;



// WEBPACK FOOTER //
// ./src/components/howto.jsx